import '../../css/base.css';

const Footer = () => {

  return (
    <div className="footer">
    <div className="row">
        <div className="col-3 col-md-2 order-1 order-md-1 footer-col footer-label" >
          email:
        </div>
        <div className="col-9 col-md-4 order-2 order-md-2 footer-col footer-text" >
          mervyn_evans@hotmail.com
        </div>
        <div className="col-3 col-md-2 order-5 order-md-3 footer-col footer-label" >
          mobile:
        </div>
        <div className="col-9 col-md-4 order-6 order-md-4 footer-col">
          +447968748839
        </div>
        <div className="col-3 col-md-2 order-3 order-md-5 footer-col" >
        </div>
        <div className="col-9 col-md-4 order-4 order-md-6 footer-col footer-text" >
          lisa_ann_evans@hotmail.com
        </div>
        <div className="col-3 col-md-2 order-7 order-md-7 footer-col" >
        </div>
        <div className="col-9 col-md-4 order-8 order-md-8 footer-col">
          +447968753361
        </div>
    </div>
  </div>
  );
}

export default Footer;